import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { UserData } from '../models/list-data/user_data';
import { environment } from '../../../environments/environment';

@Injectable()
export class ListUserService {
    constructor(private http: HttpClient) { }
    getUserList() {
        this.http.get<UserData>(`${environment.api}users/1`).subscribe(res => {
            sessionStorage.setItem('userlist', JSON.stringify(res['data']));
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/list-user.service.ts